var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,style:(_vm.stylees)},[(_vm.key.indexOf('/app-login') === -1)?_c('router-view'):_vm._e(),_vm._v(" "),_c('m-error-App',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorApp),expression:"errorApp"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.errorApp),expression:"!errorApp"}],ref:"animateApp",domProps:{"innerHTML":_vm._s(_vm.appContent)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/appMain.vue